export default __webpack_public_path__ + "static/media/nflStaff1.89c6f5ca.jpg";